import { render, staticRenderFns } from "./auth-details.component.vue?vue&type=template&id=2a22268e&scoped=true"
import script from "./auth-details.component.vue?vue&type=script&lang=js"
export * from "./auth-details.component.vue?vue&type=script&lang=js"
import style0 from "./auth-details.component.vue?vue&type=style&index=0&id=2a22268e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22268e",
  null
  
)

export default component.exports